import { render, staticRenderFns } from "./annualReportList.vue?vue&type=template&id=fbf63b5a&scoped=true"
import script from "./annualReportList.vue?vue&type=script&lang=js"
export * from "./annualReportList.vue?vue&type=script&lang=js"
import style0 from "./annualReportList.vue?vue&type=style&index=0&id=fbf63b5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbf63b5a",
  null
  
)

export default component.exports